export type PreviewAsset = {
  url: string;
  name: string;
  mimeType: string;
};

export function assetKind(asset: PreviewAsset) {
  const value = `${asset.mimeType} ${asset.name}`.toLowerCase();
  if (/gltf|glb|fbx|obj|usdz|stl|mesh|model\/3d/.test(value))
    return "model3d" as const;
  if (/tileset|tile|atlas/.test(value)) return "tileset" as const;
  if (/sprite|spritesheet|sprite-sheet/.test(value)) return "sprite" as const;
  return null;
}
